<template>
  <div v-if="list_data && list_type">
    <v-card-text :style="height_style">
      <v-layout row wrap>
        <v-flex xs6 pr-1>
          <div v-for="field in left_fields" v-show="show_field(field) && is_access(field)">
            <div v-if="field.type == 'group'">
              <div v-for="gfield in field.fields" v-show="show_field(gfield) && is_access(field)">
                <component v-bind:is="get_field_type(gfield.type)" v-bind="gfield" v-model="list_data.data" :ref="gfield.name"></component>
              </div>
            </div>
            <div v-else>
              <component v-bind:is="get_field_type(field.type)" v-bind="field" v-model="list_data.data" :ref="field.name"></component>
            </div>

            <S3UploadProgress v-if="field.type == 's3file'" :data-id="id" :field-name="field.name" :field-value="list_data.data" />
          </div>

        </v-flex>

        <v-flex xs6 pl-1>
          <div v-for="field in right_fields" v-show="show_field(field) && is_access(field)">
            <div v-if="field.type == 'group'">
              <div v-for="gfield in field.fields" v-show="show_field(gfield) && is_access(field)">
                <component v-bind:is="get_field_type(gfield.type)" v-bind="gfield" v-model="list_data.data" :ref="gfield.name"></component>
              </div>
            </div>
            <div v-else>
              <component v-bind:is="get_field_type(field.type)" v-bind="field" v-model="list_data.data" :ref="field.name"></component>
            </div>

            <S3UploadProgress v-if="field.type == 's3file'" :data-id="id" :field-name="field.name" :field-value="list_data.data" />
          </div>
        </v-flex>

      </v-layout>

    </v-card-text>
    <v-card-actions v-if="hideactions != true">
      <v-spacer></v-spacer>
      <v-btn flat @click="reset">Reset</v-btn>
      <v-btn color="success" v-if="$is_privilege('developer')" @click="copy_json()">Copy JSON</v-btn>
      <v-btn color="error" 
        v-show="list_data.state != 'archived' && !list_type.fields['disable_hide/show'] " 
        @click="changeState('archived')"
      >Hide</v-btn>
      <v-btn color="error" 
        v-show="list_data.state == 'archived' && !list_type.fields['disable_hide/show']" 
        @click="changeState('active')"
      >Show</v-btn>
      <v-btn color="success" @click="save(false)">Save</v-btn>
      <v-btn color="success" @click="save(true)">Save and close</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import * as FormItems from '@/components/form_items'
import S3UploadProgress from '@/components/content/S3UploadProgress'

import ContentModel from '@/models/content.js'
import { v4 as uuidv4 } from 'uuid';

export default {
  props: ['id', 'data', "initial", "noheight", "hideactions"],

  components: {
    ...FormItems,
    S3UploadProgress
  },

  data() {
    var ch = this.$cloudserver.channel((typeof(this.id) == "undefined" ? "cms:list_data:create" : "cms:list_data:" + this.id));
    return {
      ws_channel: ch,
      list_data: this.convert(ch.data),
    };
  },

  watch: {
    'ws_channel.data': {
      handler(val) {
        this.list_data = this.convert(val)
      },
      deep: true
    },
    'initial': {
      handler(val) {
        this.list_data = this.convert(this.ws_channel.data);
      }
    }
  },

  computed: {
    height_style () {
      if (this.noheight) {
        return "";
      }
      return "height: 532px; overflow: auto;";
    },

    content_list () {
      return _.find(this.content_lists, (cl) => {
        return cl.id == this.data;
      });
    },
    left_fields () {
      return _.filter(this.fields, function(field) {
        if (typeof(field.position) == "undefined" || field.position == "left") return true;
      });
    },
    right_fields () {
      return _.filter(this.fields, function(field) {
        if (field.position == "right") return true;
      });
    },
    fields () {
      var lt = this.list_type;
      return lt.fields["fields"];
    },
    list_type () {
      var cl = this.content_list;
      return _.find(this.list_types, (lt) => {
        return lt.id == cl.cms_list_type_id;
      });
    },
    content_lists () {
      return Object.values(this.$store.state.cms_lists);
    },
    list_types () {
      return Object.values(this.$store.state.cms_list_types);
    }
  },

  created() {
    this.ws_channel.join();
  },

  methods: {
    copy_json() {
      var data = _.cloneDeep(this.list_data);
      var textToCopy = JSON.stringify(data.data);
      var textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand('copy');
      textArea.remove();
    },
    get_field_type(field_type) {
      return ContentModel.get_field_type(field_type);
    },
    is_access(field) {
      if (field.admin_only === true) {
        return this.$is_admin();
      }
      return true;
    },
    show_field(field) {
      var self = this;
      var show = field.show;
      if (typeof(show) != "undefined") {
        var retval = false;
        _.each(show, (filter) => {
          if (Array.isArray(filter.value)) {
            if (filter.value.includes(self.list_data.data[filter.field]) ) {
              retval = true;
            }
          } else {
            if (self.list_data.data[filter.field] ==  filter.value) {
              retval = true;
            }
          }
        });
        return retval;
      } else {
        return true;
      }
    },
    get_file_field_name(name) {
      return "file_field_"+name;
    },
    filter_content_lists (filter) {
      if (typeof(filter) != "undefined") {
        return _.filter(this.content_lists, (cl) => {
          return cl.type == filter;
        });
      }
      return this.content_lists;
    },
    convert (val) {
      var self = this;
      var data = _.cloneDeep(val.list_data);

      _.each(this.fields, (field) => {

        if(typeof(self.initial) != "undefined") {
          if(!_.isNil(self.initial[field.name]) || _.isBoolean(self.initial[field.name])) {
            data.data[field.name] = self.initial[field.name];
          }
        }

        if(field.type == "uuid" && _.isEmpty(data.data[field.name])) {
          data.data[field.name] = uuidv4();
        }

      })
      return data;
    },
    reset() {
      this.list_data = this.convert(this.ws_channel.data);
    },
    delete_item () {

    },

    upload_files(msg, success, failed) {
      console.log("Uploading files", msg)

      var self = this

      // Collect file field values for save sends
      let s3Uploads = false
      let s3ListData = {}

      let backendUploads = false
      let formData = new FormData()

      _.each(this.fields, (field) => {
        if (field.type == "file") {
          // Found regular file upload field, add to form data object for API send
          let ref = this.$refs[field.name][0].get_file_field()

          if (typeof(ref.files[0]) !== "undefined") {
            formData.append(field.name, ref.files[0])
            backendUploads = true
          }
        } else if (field.type == "s3file") {
          // Found S3 direct upload field, add to browser side upload queue
          let ref = this.$refs[field.name][0].get_file_field()

          if (typeof(ref.files[0]) !== "undefined") {
            // Build key: data id / field name _ timestamp . ext
            let timestamp = Math.round((new Date().getTime()) / 1000)
            let fileObj = ref.files[0]
            let fileExt = fileObj.name.split('.').pop() // "test.image.jpg" -> "jpg"
            let fileKey = msg.id + '/' + field.name + '_' + timestamp + '.' + fileExt

            // Send data to backgroud downloader system
            this.$store.dispatch(
              's3uploader/addUpload',
              {
                dataId: msg.id,
                fieldName: field.name,
                fileObj: fileObj,
                fileKey: fileKey,
                startProcessing: false
              }
            )

            // Add field to list item data update
            // Set "url" field to "" later if this is first file or updates over existing file
            // data. Backend S3 notification will update this field with new URL and we use
            // previous file URL until that is completed.
            s3ListData[field.name] = {
              "status": "new",
              "key": fileKey,
              //"url": "",
              "statusMessage": "",
              "statusUpdatedAt": (new Date().toISOString()) // Field display uses Date.parse()
            }

            s3Uploads = true
          }
        }
      })

      // Send all regular files to backend with single HTTP request
      if (backendUploads == true) {
        this.$http
          .post("content/upload/" + msg.id, formData, {"responseType": "text"})
          .then(
            (response) => {
              console.log("File uploaded", response)
              if(_.isFunction(success)) success(response);
            },
            (err) => {
              console.log("File upload failed", err)
              if(_.isFunction(failed)) failed(err);
            }
          )
      }

      // Update list item data with S3 file fields added for upload
      if (s3Uploads == true) {
        // Start upload queue processing
        this.$store.dispatch('s3uploader/processUpload')

        // Update S3 field data objects
        // TODO Parse/encode JSON
        let send_list_data = _.cloneDeep(this.list_data)
        send_list_data.cms_list_id = self.data

        Object.entries(s3ListData).forEach(([key, value]) => {
          // Get reference to data file field or add key if missing (new field uploading first time)
          if (typeof(send_list_data.data[key]) === "undefined") {
            send_list_data.data[key] = {}
          }
          let file_data = send_list_data.data[key]

          // Copy form field data over list data item fields
          Object.entries(value).forEach(([fieldKey, fieldValue]) => {
            file_data[fieldKey] = fieldValue
          })

          // Check if previous upload data exists
          // Set empty url if missing, otherwise leave previous URL intact
          if (typeof(file_data["url"]) == "undefined") {
            file_data["url"] = ""
          }
        })

        this.ws_channel
          .push("save", {list_data: send_list_data})
          .receive("ok", (msg) => {
            //self.$message.success("List data s3 fields were updated!")

            // Set local data with successfully updated backend data
            // Will be replaced soon with backend list data update channel message
            self.list_data = msg
            if(_.isFunction(success)) success(msg);
          })
          .receive("error", (msg) => {
            // TODO Remove after testing, backend S3 notification will update the field on error
            console.log("List data S3 field update failed", msg)
            //self.$message.warning("Error updating s3 fields list data!")
            if(_.isFunction(failed)) failed(msg);
          })
      }
      if(!backendUploads && !s3Uploads) {
        if(_.isFunction(success)) success(undefined);
      }
    },

    changeState (state) {
      this.list_data.state = state;
      this.save(false);
    },

    save (close, hide_messages, success, failed) {
      var self = this;

      if (typeof(this.ws_channel) != "undefined") {
        // Prepare save data for send
        let send_list_data = _.cloneDeep(this.list_data);
        send_list_data.cms_list_id = self.data;

        // Clean File objects from data
        _.each(send_list_data.data, (value, key) => {
          if(value instanceof File) {
            delete send_list_data.data[key];
          }
        });
        this.ws_channel
          .push("save", {list_data: send_list_data})
          .receive("ok", (msg) => {

            // Set local data with successfully updated backend data
            // Will be replaced soon with backend list data update channel message
            self.list_data = msg

            self.upload_files(msg, (msg) => {
              if (typeof(self.id) == "undefined") {
                if(!hide_messages) self.$message.success("List data was created!");
              } else {
                if(!hide_messages) self.$message.success("List data was updated!");
              }
              if(close) { this.$root.close_bottom_sheet() }
              if(_.isFunction(success)) success(msg);
            }, (msg) => {
              if (typeof(self.id) == "undefined") {
                if(!hide_messages) self.$message.warning("Unable to create list data!");
              } else {
                if(!hide_messages) self.$message.warning("Unable to update list data!");
              }
              this.channel.push("delete", {list_data: self.list_data})
              if(_.isFunction(failed)) failed(msg);
            });
          })
          .receive("error", (msg) => {
            console.log("Content item save error", msg);

            if (typeof(self.id) == "undefined") {
              if(!hide_messages) self.$message.warning("Unable to create list data!");
            } else {
              if(!hide_messages) self.$message.warning("Unable to update list data!");
            }
            if(_.isFunction(failed)) failed(msg);
          });
      }
    }
  }
}
</script>
